import fb from '../firebase'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import FireData from '../data/FireData'
import DataHelpers from '../helpers/DataHelpers'
import ContactHelpers from '../helpers/ContactHelpers'
import ListHelpers from '../helpers/ListHelpers'
import { debug } from 'util';


var db = fb.database()

const state = {
    recentContacts: [],
    recentContactsForUser: [],
    //searchContactsTerm: '',
    searchContacts1: [],
    searchContacts2: [],
    searchTerm: '',
    shallowSearch: false,
}

// getters
const getters = {
    getRecentContactsForUser(state) {
        return state.recentContactsForUser
        // let arr = [] 
        // state.recentContactsForUser.forEach(item => {
            
        //     if(item.tenantKey) {
        //         let ref = db.ref('tenants').child(item.tenantKey).child('contacts').child(item.key)
        //         FireData.fetchItemSingle(ref).then(contact => {
                    
        //             arr.push(contact)
        //         })
        //     }

        // })

        // return arr
        
    },

    getExpandedRecentContacts(state) {
        let arr = [] 
        state.recentContactsForUser.forEach(item => {  
            let ref = db.ref('tenants').child(item.tenantKey).child('contacts').child(item.key)
            ref.on('value', snap => {
                arr.push(FireData.snapToObj(snap))
            })
        })
        return arr        
    },

    shallowSearch: state => {
        return state.shallowSearch
    },

    searchTerm: state => {
        return state.searchTerm
    },

    recentContacts: state => {
        return state.recentContacts
    },
    searchResults: state => {
        return {...state.searchContacts1, ...state.searchContacts2}
    },
    contacts: (state, getters) => { 
        let searchTerm = getters.searchTerm
        console.log('ContactsStore > contacts > searchTerm', searchTerm)
        let names = ContactHelpers.searchNames(searchTerm)
        
        const searchContacts = DataHelpers.unionByKey(state.searchContacts1, state.searchContacts2)
        let combinedContacts = DataHelpers.unionByKey(state.recentContacts, searchContacts)

        return combinedContacts.filter(o => {
            if(!o.firstName || !o.lastName)
                return true

            if(o.firstName.startsWith(names.primaryName) && o.lastName.startsWith(names.secondaryName))
                return true

            if((o.lastName.startsWith(names.primaryName) && o.firstName.startsWith(names.secondaryName)))
                return true
            
            return false            
        }).slice(0,20)
    }
}

// actions
const actions = {

    loadContactsToArray(context, payload) {

        if(ContactHelpers.isMobileSearch(payload.search)) {
            let mobRef = db.ref(`tenants/${context.getters.tenantKey}/contacts`).orderByChild('mobileSearch').equalTo(payload.search).limitToLast(20)
            mobRef.on('value', function(snap) {
                FirebaseHelpers.snapshotPushArray(snap, payload.contacts) 
                console.log('found by mobile', payload.contacts)
                                
            })
            return    
        }
        
        let names = ContactHelpers.searchNames(payload.search)
        let primaryName = names.primaryName
        
        console.log('store > loadContactsToArray', primaryName)
        

        let ref1 = db.ref(`tenants/${context.getters.tenantKey}/contacts`).orderByChild('firstName').startAt(primaryName).endAt(primaryName + '\uf8ff').limitToLast(20)
        ref1.on('value', function(snap) {
            console.log('store > loadContactsToArray > snap1', snap.val())
            FirebaseHelpers.snapshotPushArray(snap, payload.contacts) 

            let ref2 = db.ref(`tenants/${context.getters.tenantKey}/contacts`).orderByChild('lastName').startAt(primaryName).endAt(primaryName + '\uf8ff').limitToLast(20)
            ref2.on('value', function(snap) {
                console.log('store > loadContactsToArray > snap2', snap.val())
                FirebaseHelpers.snapshotPushArray(snap, payload.contacts) 
            })

        })

        console.log('store > loadContactsToArray', payload)
            
    
    },

    loadRecentContacts(context) {
        if(!context.getters.status('recentContacts')) {
            context.commit('status', {
                name: 'recentContacts',
                status: 'Loading'
            })

            // get first 10 for speed
            let ref = db.ref(`tenants/${context.getters.tenantKey}/contacts`).orderByChild('user').equalTo(null).limitToLast(10)
            ref.on('value', function(snap) {
                let items = FirebaseHelpers.snapshotToArray(snap, true)
                context.commit('recentContacts', items)
                context.commit('status', {
                    name: 'recentContacts',
                    status: 'Loaded'
                })
            }) 
            
            // get the rest later
            setTimeout( ()=> {
                ref = db.ref(`tenants/${context.getters.tenantKey}/contacts`).orderByChild('user').equalTo(null).limitToLast(100)
                ref.on('value', function(snap) {
                    let items = FirebaseHelpers.snapshotToArray(snap, true)
                    context.commit('recentContacts', items)
                }) 
            }, 2000)
        }
    },
}

// mutations
const mutations = {

    addRecentContactForUser(state, recent) {
        console.log('ContactsStore > addRecentContactForUser')
        ListHelpers.delete(recent, state.recentContactsForUser)
        state.recentContactsForUser.unshift(recent)     
        if(state.recentContactsForUser.length > 10)
            state.recentContactsForUser.pop()
    },

    setRecentContactsForUser(state, recents) {
        state.recentContactsForUser = recents       
    },

    shallowSearch (state, value) {
        state.shallowSearch = value           
    },              
    searchTerm (state, searchTerm) {
        state.searchTerm = searchTerm           
    },              
    recentContacts (state, recentContacts) {
        state.recentContacts = recentContacts           
    },              
    searchContacts1 (state, results) {
        state.searchContacts1 = results           
    },              
    searchContacts2 (state, results) {
        state.searchContacts2 = results           
    }, 
    clearSearchContacts (state) {
        state.searchContacts1 = []         
        state.searchContacts2 = []           
    }, 

    searchResults (state, results) {
        state.searchResults = results           
    },  
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/ContactsStore.js